import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { IListBase } from 'app/contracts/base/list-base';

import { ErrorHandler } from 'app/helpers/error-handler';

import { HttpClientService } from 'app/services/yoklama/http-client-service';
import { environment } from 'environments/environment';

import { Observable, catchError, lastValueFrom } from 'rxjs';
import { UnifiedAuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class CMSDynamicService {
  private _token: string | null = null;

  constructor(
    private httpClientService: HttpClientService,
    public alertService: CustomToastrService,
    private errorHandler: ErrorHandler,
    private authService: UnifiedAuthService,
  ) {}
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken');

    return new HttpHeaders({
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });
  }

  async get(
    page: number = 0,
    size: number = 20,
    controller: string = '',
    action: string = '',
    filter: string = '',
  ): Promise<any> {
    const finalQuery = filter.length
      ? `Page=${page}&PageSize=${size}&${filter}`
      : `Page=${page}&PageSize=${size}`;

    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,
          queryString: finalQuery, // sadece finalQuery yeterli
          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

    var res = await lastValueFrom(promiseData);

    return res;
  }
  async getListe(

    controller: string = '',
    action: string = '',
    filter: string = '',
  ): Promise<any> {


    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,

          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

    var res = await lastValueFrom(promiseData);

    return res;
  }
async getUrl(url: string): Promise<any> {
  const promiseData: Observable<any> = this.httpClientService
    .get({
      fullEndPoint: url,
      headers: this.getAuthHeaders(),
    })
    .pipe(
      catchError((error) => {
        throw this.errorHandler.getServerErrorMessage(error);
      }),
    );

  const res = await lastValueFrom(promiseData);
  return res;
}
  async getBasic(
    controller: string = '',
    action: string = '',
    queryString: string = '',
  ): Promise<any> {
    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,
          queryString: queryString, // sadece finalQuery yeterli
          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

    var res = await lastValueFrom(promiseData);

    return res;
  }
  async getBildirim(
    controller: string = '',
    action: string = '',
    filter: string = '',
  ): Promise<any> {
    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,

          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

    var res = await lastValueFrom(promiseData);

    return res;
  }
  async ebsGet(
    page: number = 0,
    size: number = 20,
    controller: string = '',
    action: string = '',
    filter: string = '',
    websiteId?: number,
    str = '',
    deger: boolean = false,
  ): Promise<any> {
    var website = 0;
    var websiteStr = '';
    if (websiteId != null) {
      website = websiteId;
    }

    const finalQuery = `Page=${page}&PageSize=${size}&${filter}`;

    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,
          queryString: finalQuery, // sadece finalQuery yeterli
          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );
    var res = await lastValueFrom(promiseData);
    return res;
  }

  async getAllIdData(
    page: number = 0,
    size: number = 20,
    controller: string = '',
    action: string = '',
    filter: string = '',
    id: string = '',
  ): Promise<any> {
    var idStr = '';
    if (id != null) {
      idStr = id;
    }

    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,
          queryString: `Page=${page}&PageSize=${size}${idStr}${filter}`,
          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );
    var res = await lastValueFrom(promiseData);

    return res;
  }

  async getAllData(
    page: number = 0,
    size: number = 20,
    controller: string = '',
    action: string = '',
    filter: string = '',
  ): Promise<any> {
    const promiseData: Observable<IListBase<any[]> | any> =
      this.httpClientService
        .get({
          controller: controller,
          action: action,
          queryString: `Page=${page}&PageSize=${size}&${filter}`,
          headers: this.getAuthHeaders(),
        })
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );
    var res = await lastValueFrom(promiseData);

    return res;
  }

  async LoginPost(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
    messageStatus = true,
  ): Promise<any> {
    try {
      const promiseData: Observable<any> = this.httpClientService
        .post(
          {
            controller: controller,
            action: action,
            headers: this.getAuthHeaders(),
          },
          body,
        )
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

      const res = await lastValueFrom(promiseData);

      if (messageStatus) {
        if (res.status) {
        //  console.log(res);
          return this.alertService.message(
            message || res.message || 'İşlem başarılı',
            'Başarılı',
            {
              messageType: ToastrMessageType.Success,
              position: ToastrPosition.TopFullWidth,
            },
          );
        } else {
          return this.alertService.message(
            res.message || 'Bir hata oluştu',
            'Hata',
            {
              messageType: ToastrMessageType.Error,
              position: ToastrPosition.TopFullWidth,
            },
          );
        }
      }

      return res;
    } catch (err) {
      console.error(err);
    }
  }

  async post(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
    messageStatus = true,
  ): Promise<any> {
    try {
      const promiseData: Observable<any> = this.httpClientService
        .post(
          {
            controller: controller,
            action: action,
            headers: this.getAuthHeaders(),
          },
          { items: body },
        )
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

      const res = await lastValueFrom(promiseData);

      if (messageStatus) {
        if (res.status) {
         // console.log(res);
          return this.alertService.message(
            message || res.message || 'İşlem başarılı',
            'Başarılı',
            {
              messageType: ToastrMessageType.Success,
              position: ToastrPosition.TopFullWidth,
            },
          );
        } else {
          return this.alertService.message(
            res.message || 'Bir hata oluştu',
            'Hata',
            {
              messageType: ToastrMessageType.Error,
              position: ToastrPosition.TopFullWidth,
            },
          );
        }
      }

      return res;
    } catch (err) {
      console.error(err);
    }
  }

  async postItem(
    controller: string = '',
    action: string = '',
    message: string = '',
    item: any,
    messageStatus = true,
  ): Promise<any> {
    try {
     // console.log(item);
      const promiseData: Observable<any> = this.httpClientService
        .post(
          {
            controller: controller,
            action: action,
            headers: this.getAuthHeaders(),
          },
          { item },
        )
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

      const res = await lastValueFrom(promiseData);

      if (messageStatus) {
        if (res.status) {
         // console.log(res);
          return this.alertService.message(
            message || res.message || 'İşlem başarılı',
            'Başarılı',
            {
              messageType: ToastrMessageType.Success,
              position: ToastrPosition.TopFullWidth,
            },
          );
        } else {
          return this.alertService.message(
            res.message || 'Bir hata oluştu',
            'Hata',
            {
              messageType: ToastrMessageType.Error,
              position: ToastrPosition.TopFullWidth,
            },
          );
        }
      }

      return res;
    } catch (err) {
      console.error(err);
    }
  }
  async postSMS(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
    messageStatus = true,
  ): Promise<any> {
    try {
      const promiseData: Observable<any> = this.httpClientService
        .post(
          {
            controller: controller,
            action: action,
            headers: this.getAuthHeaders(),
          },
          { item: body },
        )
        .pipe(
          catchError((error) => {
            throw this.errorHandler.getServerErrorMessage(error);
          }),
        );

      const res = await lastValueFrom(promiseData);

      if (messageStatus) {
        if (res.status) {
         // console.log(res);
          return this.alertService.message(
            message || res.message || 'İşlem başarılı',
            'Başarılı',
            {
              messageType: ToastrMessageType.Success,
              position: ToastrPosition.TopFullWidth,
            },
          );
        } else {
          return this.alertService.message(
            res.message || 'Bir hata oluştu',
            'Hata',
            {
              messageType: ToastrMessageType.Error,
              position: ToastrPosition.TopFullWidth,
            },
          );
        }
      }

      return res;
    } catch (err) {
      console.error(err);
    }
  }
  async postCustom(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
  ): Promise<any> {
    const promiseData: Observable<any> = this.httpClientService
      .post(
        {
          controller: controller,
          action: action,
          headers: this.getAuthHeaders(),
        },
        body,
      )
      .pipe(
        catchError((error) => {
          console.log(error);
          throw this.errorHandler.getServerErrorMessage(error);
        }),
      );

    var res = await lastValueFrom(promiseData);
    return this.alertService.message(
      message + '. Yönlendiriliyorsunuz',
      'Başarılı',
      {
        messageType: ToastrMessageType.Success,
        position: ToastrPosition.TopRight,
      },
    );
  }

  async postFileUpload(
    controller: string = '',
    action: string = '',
    files: FileList,
  ): Promise<any> {
    if (!files || files.length === 0) throw new Error('Dosya seçilmedi');

    const formData = new FormData();
    formData.append('file', files[0]); // field adı 'file'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this._token,
      // NOT: Content-Type burada yok, Angular otomatik ayarlıyor
    });

    try {
      const observable: Observable<any> = this.httpClientService.post(
        {
          controller,
          action,
          headers,
        },
        formData,
      );

      const res = await lastValueFrom(observable);
      return res; // backend'den gelen { dbPath, imageUrl } objesi
    } catch (error) {
      console.error('Upload hatası:', error);
      throw error;
    }
  }

  async delete(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
  ): Promise<any> {
    const promiseData: Observable<any> = this.httpClientService
      .delete(
        {
          controller: controller,
          action: action,
          headers: this.getAuthHeaders(),
        },
        body,
      )
      .pipe(
        catchError((error) => {
          throw this.errorHandler.getServerErrorMessage(error);
        }),
      );

    var res = await lastValueFrom(promiseData);
    return this.alertService.message(
      message + '. Yönlendiriliyorsunuz',
      'Başarılı',
      {
        messageType: ToastrMessageType.Success,
        position: ToastrPosition.TopFullWidth,
      },
    );
  }
  async put(
    controller: string = '',
    action: string = '',
    message: string = '',
    body: any,
    /* successCallBack: () => void,
    errorCallBack: (errorMessage: string) => void */
  ): Promise<any> {
    const promiseData: Observable<any> = this.httpClientService
      .put(
        {
          controller: controller,
          action: action,
          headers: this.getAuthHeaders(),
        },
        { items: body },
      )
      .pipe(
        catchError((error) => {
          console.log(error);
          throw this.errorHandler.getServerErrorMessage(error);
        }),
      );

    var res = await lastValueFrom(promiseData);
    return this.alertService.message(
      message + '. Yönlendiriliyorusnuz',
      'Başarılı',
      {
        messageType: ToastrMessageType.Success,
        position: ToastrPosition.TopFullWidth,
      },
    );
  }
}
